import React from "react";
import Select from "react-select";
import { isArray } from "validate.js";
import styles from "./index.module.scss";
const cssSelectedColor = "var(--alt-highlighted-text-color)";
const cssErrorColor = "#c54039";
const cssTagBackgroundColor = "#dae3e7";
const textColor = "#58585a";
export default class Dropdown extends React.Component {
    static defaultProps = {
        title: "",
    };
    constructor(props) {
        super(props);
        this.state = { options: this.getOptions() };
    }
    componentDidUpdate(previousProps) {
        if (previousProps.options !== this.props.options) {
            this.setState({ options: this.getOptions() });
        }
    }
    handleErrors = () => {
        if (this.props.error && this.props.setErrors) {
            this.props.setErrors({});
        }
    };
    getOptions = () => {
        const { filterOptions = () => true } = this.props;
        return (this.props.options ||
            Object.keys(this.props.enum)
                .filter((k) => typeof this.props.enum[k] === "number")
                .map((k) => ({
                value: this.props.enum[k],
                label: k.replaceAll("_", ` `),
            }))
                .filter((element) => filterOptions(element)));
    };
    onChange = (option) => {
        this.props.onChange({
            field: this.props.name,
            option,
        });
    };
    findValue = (options) => {
        if (this.props.value === undefined) {
            return null;
        }
        if (this.props.isMulti) {
            return options.filter(({ value }) => isArray(this.props.value) &&
                this.props.value.includes(value));
        }
        return options.find(({ value }) => value === this.props.value) || null;
    };
    render() {
        const isNewDesign = this.props.newDesign === true;
        const css = {
            container: (provided) => {
                return {
                    ...provided,
                    width: "100%",
                    borderRadius: isNewDesign ? "8px" : "3px",
                    maxHeight: "auto",
                };
            },
            valueContainer: (provided) => {
                return {
                    ...provided,
                    maxHeight: "auto",
                    minHeight: isNewDesign ? "40px" : "1vw",
                    padding: isNewDesign ? "8px 12px" : "2px",
                    position: "unset",
                };
            },
            indicatorsContainer: (provided) => {
                return {
                    ...provided,
                    maxHeight: isNewDesign ? "40px" : "1.5vw",
                    minHeight: isNewDesign ? "40px" : "1vw",
                };
            },
            singleValue: (provided) => {
                return {
                    ...provided,
                    top: "50%",
                    width: "100%",
                    fontFamily: isNewDesign
                        ? '"Open Sans", sans-serif'
                        : provided.fontFamily,
                    fontSize: isNewDesign ? "14px" : provided.fontSize,
                    color: isNewDesign ? "#000000" : provided.color,
                    lineHeight: isNewDesign ? "20px" : provided.lineHeight,
                };
            },
            multiValue: (provided) => {
                return {
                    ...provided,
                    marginRight: "4px",
                    backgroundColor: cssTagBackgroundColor,
                    marginTop: "-0.3vw",
                    maxHeight: "1.5vw",
                    alignItems: "center",
                };
            },
            placeholder: (provided) => {
                return {
                    ...provided,
                    color: this.props.error
                        ? cssErrorColor
                        : isNewDesign
                            ? "#888f97"
                            : provided.color,
                    top: "50%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontFamily: isNewDesign
                        ? '"Open Sans", sans-serif'
                        : provided.fontFamily,
                    fontSize: isNewDesign ? "14px" : provided.fontSize,
                };
            },
            indicatorSeparator: (provided) => {
                return {
                    ...provided,
                    maxHeight: "2vw",
                    minHeight: "1vw",
                    display: "none",
                };
            },
            dropdownIndicator: (provided) => {
                return {
                    ...provided,
                    ...(isNewDesign
                        ? {
                            color: "#0eabdb",
                            padding: "8px 12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "40px",
                            cursor: "pointer",
                        }
                        : {
                            color: cssSelectedColor,
                            maxHeight: "2vw",
                            minHeight: "1vw",
                        }),
                };
            },
            option: (provided, state) => {
                return {
                    ...provided,
                    backgroundColor: state.isSelected
                        ? isNewDesign
                            ? "rgba(14, 171, 219, 0.08)"
                            : cssSelectedColor
                        : state.isFocused
                            ? isNewDesign
                                ? "rgba(14, 171, 219, 0.04)"
                                : provided.backgroundColor
                            : provided.backgroundColor,
                    color: state.isSelected && isNewDesign
                        ? "#0eabdb"
                        : provided.color,
                    fontFamily: isNewDesign
                        ? '"Open Sans", sans-serif'
                        : provided.fontFamily,
                    fontSize: isNewDesign ? "14px" : provided.fontSize,
                    padding: isNewDesign ? "8px 12px" : provided.padding,
                };
            },
            control: (provided, state) => {
                return {
                    ...provided,
                    maxHeight: isNewDesign ? "40px" : "2vw",
                    minHeight: isNewDesign ? "40px" : "1vw",
                    border: isNewDesign
                        ? state.isFocused
                            ? "1px solid #0eabdb"
                            : "1px solid #ccd4dc"
                        : "none",
                    borderWidth: "1px",
                    boxShadow: isNewDesign
                        ? "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
                        : "none",
                    "&:hover": {
                        border: isNewDesign ? "1px solid #0eabdb" : "none",
                    },
                    borderRadius: this.props.title.length > 0
                        ? "0 2px 2px 0"
                        : isNewDesign
                            ? "8px"
                            : "4px",
                    padding: 0,
                    backgroundColor: isNewDesign
                        ? "white"
                        : provided.backgroundColor,
                };
            },
            menu: (provided) => {
                return {
                    ...provided,
                    position: this.props.relative ? "relative" : "absolute",
                    zIndex: 999,
                    color: textColor,
                    borderRadius: isNewDesign ? "8px" : provided.borderRadius,
                    boxShadow: isNewDesign
                        ? "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
                        : provided.boxShadow,
                    border: isNewDesign ? "1px solid #ccd4dc" : provided.border,
                    marginTop: isNewDesign ? "4px" : provided.marginTop,
                };
            },
        };
        const { options } = this.state;
        const value = this.findValue(options);
        return (React.createElement("div", { className: `${styles.wrapper} ${isNewDesign ? styles.newDesign : ""}` },
            this.props.title.length > 0 ? (React.createElement("div", { className: styles.title }, this.props.title)) : (React.createElement(React.Fragment, null)),
            React.createElement(Select, { ...{
                    ...this.props,
                    styles: css,
                    options,
                    value,
                    onChange: this.onChange,
                    isDisabled: this.props.disabled,
                }, isClearable: false, onFocus: this.handleErrors })));
    }
}
